<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { inject, computed, onMounted, onUnmounted, watch } from 'vue'
import type {WizardContext} from "@/types/wizard.ts";

const props = defineProps<{
  name: string
  validate?: () => boolean | Promise<boolean>
}>()

const wizard = inject<WizardContext>('wizard')

const isActive = computed(() => wizard?.currentStep.value === props.name)

onMounted(() => {
  wizard?.registerStep({
    name: props.name,
    validate: props.validate,
  })
})

onUnmounted(() => {
  wizard?.unregisterStep(props.name)
})
</script>
